import { styled } from 'styled-components';
import { Media } from '../../../../theme/Media.js';
import { BORDER_RADIUS } from '../constants.js';
export const DragHandleButton = styled.button `
  all: unset;
  cursor: grab;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    cursor: grabbing;
  }

  // 'all: unset' strips the default outline; restore a visible focus ring for keyboard users
  // (the handle is reachable via @dnd-kit's KeyboardSensor). Matches the V2 Button focus pattern.
  &:focus-visible {
    outline: none;
    ${({ theme }) => theme.shadows.focus}
  }
`;
export const OverlayWrapper = styled.div `
  ${({ theme }) => theme.shadows.large};
  border-radius: ${BORDER_RADIUS};
  overflow: hidden;
  cursor: grabbing;
  background: ${({ theme }) => theme.colors.grey00_1};

  // Clip the overlay to the table's visible viewport when the row is wider than
  // the scroll container. @dnd-kit sizes the overlay to the source row width,
  // which can extend past the visible table; the margin-left + capped width
  // keep the visible slice aligned with the table's current scroll position.
  margin-left: ${({ $scrollLeft }) => $scrollLeft}px;
  width: min(${({ $viewportWidth }) => $viewportWidth}px, 100%);

  * {
    cursor: inherit;
  }

  // Bridges a ~1-frame race at drop-end: @dnd-kit unloads its scoped stylesheet
  // (which hides [data-dnd-overlay] when not dragging) before React unmounts
  // these children, otherwise a duplicate row briefly lays out at the bottom of
  // Table.Wrapper.
  [data-dnd-overlay]:not([data-dnd-dragging]) > & {
    display: none;
  }
`;
export const OverlayGrid = styled.div `
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns};
  // Shift the full-width grid so the slice visible through OverlayWrapper shows
  // the same columns currently in view in the table.
  transform: translateX(${({ $scrollLeft }) => -$scrollLeft}px);

  @media ${Media.xsMax} {
    display: flex;
    flex-direction: column;
    transform: none;
  }
`;
